export default __webpack_public_path__ + "public/assets/images/e-oops.png";